export interface NewConversationCandidate {
    id: string;
    participantName: string;
    participantInitials: string;
    isOnline?: boolean;
    conversationSubtitle?: string;
    contextId?: string;
}
